// src/com/map_poi_all/MapPoiAllDict.js
import { TableColumnType } from "../../value/AppConst";
import { gql } from "@apollo/client";


/* ************************************************
 * MAP_POI_ALL Apollo Graphql
 * VIEW
 * Project: NewTOP for cloud
 * 2024-11-15 13:27:21 using DbdbTap.
 ************************************************ */

const MAP_POI_ALL_LIST_PART = gql`
fragment MapPoiAllListPart on MapPoiAll {
    poiKey
    poiGroup
    dcCd
    storeId
    poiName
    useYn
    poiTypeCd
    typeName
    officeTelno
    staffName
    secuTelno
    secuStaffName
    zipCd
    addr
    lat
    lon
    xCoord
    yCoord
    viewLevel
    zoneShape
    useZone
    iconSaveName
    fontColor
    backColor
}
`;

export const LIST_MAP_POI_ALL = gql`
${MAP_POI_ALL_LIST_PART}
query ListMapPoiAll {
    mapPoiAllList {
        ...MapPoiAllListPart
    }
}
`;

// mapPoiListByDc(dcCd:String!): [MapPoiAll]!
export const LIST_MAP_POI_BY_DC = gql`
${MAP_POI_ALL_LIST_PART}
query ListMapPoiByDc($dcCd: String!) {
    mapPoiListByDc(dcCd:$dcCd) {
        ...MapPoiAllListPart
    }
}
`;

/**
 * MAP_POI_ALL React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-11-15 12:57:37 using DbdbTap
 */
export const MapPoiAllDictionary = {
    errorTitle: {
        Get: 'DC, 점포정보 조회 오류',
    },
    floatingInfoProps: [
        // {id, label, print(optional, (rec, value)=>{} )}
        {
            id: 'poiName', label: '지점',
            print: (rec, value) => {
                let code = rec.poiGroup==='DC' ? rec.dcCd : rec.storeId;
                let v = rec.poiGroup==='DC' ? '[DC] ' : '[점포] ';
                return v + value + ` (${code})`;
            }
        },
        {id: 'staffName', label: '담당자'},
        {id: 'officeTelno', label: '연락처'},
        {id: 'addr', label: '주소'},
        {id: 'typeName', label: '지점타입'},
        {id: 'useZone', label: '출발,도착 감지',
            print: (rec, value) => value ? '사용' : '미사용'
        },
        {id: 'secuStaffName', label: '보안담당자'},
        {id: 'secuTelno', label: '보안연락처'},
    ],
    tableProps: {
        tableId: 'mapPoiView',
        uniqueKey: 'poiKey',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: true, // 외부에서 MapFloatingInfo를 사용해서 표시
            growToFill: true,
        },
        columns: [
            { id: 'poiName', label: '지점', width: 120, show: true,
                option:{
                    align: 'inherit',
                    print: (r, i, v) => {
                        if(r.poiGroup==='DC')
                            return <span style={{color:'blue'}}>{v}</span>;
                        else return v;
                    }
                }
            },
            { id: 'officeTelno', label: '연락처', width: 120, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'addr', label: '주소', width: 200, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'poiKey', label: '코드', width: 70, show: true,
                option:{
                    align: 'center',
                    print: (r, i, v) => r.poiGroup==='DC' ? r.dcCd : r.storeId
                }
            },
            { id: 'typeName', label: '지점타입', width: 120, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            //print using getTableColumnOption(c,t,i)
            /* { id: 'poiGroup', label: Dict.poiGroup.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dcCd', label: Dict.dcCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'storeId', label: Dict.storeId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'useYn', label: Dict.useYn.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'poiTypeCd', label: Dict.poiTypeCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'staffName', label: Dict.staffName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'secuTelno', label: Dict.secuTelno.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'secuStaffName', label: Dict.secuStaffName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'zipCd', label: Dict.zipCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'lat', label: Dict.lat.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'lon', label: Dict.lon.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'xCoord', label: Dict.xCoord.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'yCoord', label: Dict.yCoord.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'viewLevel', label: Dict.viewLevel.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'zoneShape', label: Dict.zoneShape.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'useZone', label: Dict.useZone.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'iconSaveName', label: Dict.iconSaveName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'fontColor', label: Dict.fontColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'backColor', label: Dict.backColor.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} }, */
        ]
    },
};
